'use client';

import { createContext, createElement, useContext, type ReactNode } from 'react';
import { useGmailStatusController } from './use-gmail-status-controller';
import type { GmailStatusController, GmailStatusState } from './use-gmail-status.types';

const GmailStatusContext = createContext<GmailStatusController | null>(null);

export function GmailStatusProvider({ children }: { children: ReactNode }) {
  const value = useGmailStatusController();
  return createElement(GmailStatusContext.Provider, { value }, children);
}

export function useGmailStatus(): GmailStatusController {
  const context = useContext(GmailStatusContext);
  if (!context) {
    throw new Error('useGmailStatus must be used within GmailStatusProvider');
  }

  return context;
}

export function useGmailStatusOptional(): GmailStatusController | null {
  return useContext(GmailStatusContext);
}

export type { GmailStatusController, GmailStatusState };